"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiUtil_1 = __importDefault(require("../util/ApiUtil"));
class EmailStore {
    constructor(rootStore) {
        Object.defineProperty(this, "EMAIL_POST_URL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'email'
        });
        Object.defineProperty(this, "AUTHENTICATED_EMAIL_POST_URL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'email/authenticated'
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.ssoStore = rootStore.ssoStore;
    }
    async sendContactFormEmail(emailContent) {
        if (!emailContent.requestType) {
            emailContent.requestType = 'Õigus pöörduda Telia poole';
        }
        return await ApiUtil_1.default.post(this.getEmailRequestUrl(), emailContent);
    }
    getEmailRequestUrl() {
        if (this.ssoStore.isDealer) {
            return this.ssoStore.isDealerWithSelectedCustomer ? this.AUTHENTICATED_EMAIL_POST_URL : this.EMAIL_POST_URL;
        }
        else {
            return this.ssoStore.isHardAuthWithCustomer ? this.AUTHENTICATED_EMAIL_POST_URL : this.EMAIL_POST_URL;
        }
    }
}
exports.default = EmailStore;
